<template>
<v-card-text>
    <v-row class="align-content-start flex-wrap" width="80%">
        <v-col>
            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="requiredRule" required v-model="computedDateFormattedStartDateReport" label="Start Date*" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :rules="requiredRule" v-model="startDate" no-title required @input="menu1 = false"></v-date-picker>
            </v-menu>
        </v-col>
        <v-col>
            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="requiredRule" required v-model="computedDateFormattedEndDateReport" label="End Date*" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker :rules="requiredRule" v-model="endDate" no-title required @input="menu2 = false"></v-date-picker>
            </v-menu>
        </v-col>
        <v-col>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="toCreateGroupOverview" :loading="loading">
                Submit
            </v-btn>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="toExport" :loading="isExporting">
                Export
            </v-btn>
        </v-col>
    </v-row>
</v-card-text>
</template>

<script>
import formatData from "../utils/formatData";
export default {
    data() {
        return {
            startDate: '',
            endDate: '',
            title: 'GroupViewFilter',
            menu1: false,
            menu2: false,
            requiredRule: [
                v => !!v
            ],
        };
    },
    created() {
        //update data from attr param
        if( this.$attrs.startDate ){
            this.startDate = this.$attrs.startDate;
        }
        if( this.$attrs.endDate ){
            this.endDate = this.$attrs.endDate;
        }
    },
    computed: {
        loading() {
            return this.$attrs.loading;
        },
        groupId() {
            return this.$attrs.groupId;
        },
        uid() {
            return this.$attrs.uid;
        },
        isExporting(){
            return this.$attrs.isExporting;
        },
        computedDateFormattedStartDateReport() {
            return this.formatDate(this.startDate);
        },
        computedDateFormattedEndDateReport() {
            return this.formatDate(this.endDate);
        }
    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        toCreateGroupOverview() {
            //for use submit event
            if (this.startDate != '' && this.endDate != '') {
                this.$emit('toCreateGroupOverview', { uid: this.uid, startDate: this.startDate, endDate: this.endDate, isSubmit: true });
            }
        },
        toExport(){
            this.$emit('toExport', { groupId: this.groupId, uid: this.uid, startDate: this.startDate, endDate: this.endDate});
        }
    },
};
</script>
